import { Box, Button, Card, Flex, Grid } from '@sainsburys-tech/fable'
import moment, { MomentInput } from 'moment'
import React from 'react'

import { getUserStore } from '../../../utils/localStore'
import { ICounterTemperaturesResponse } from '../../types/ICounterTemperaturesResponse'
import CounterTemperatureTable from './CounterTemperatureTable'
import { SummaryCard } from './SummaryCard'

moment.locale('en-GB')

interface IProps {
  batchDate: MomentInput
  counterTemperatureResponse: ICounterTemperaturesResponse
}

const CounterView = (props: IProps) => {
  const renderSummary = (text: string, value: string, style: string) => (
    <Card
      orientation='vertical'
      style={{
        background:
          'var(--fable-color-background-secondary-default) !important',
        padding: '24px',
        boxSizing: 'border-box',
      }}
    >
      <SummaryCard title={text} value={value} className={style} />
    </Card>
  )

  const getPrintFooter = () => {
    const store = getUserStore()
    const printDateTime = new Date()
    return `Report generated
     at ${printDateTime.getDate()}/${printDateTime.getMonth() + 1}/${printDateTime.getFullYear()} 
    ${printDateTime.getHours()}:${printDateTime.getMinutes()} for store ${store.storeId}-${store.storeName}.`
  }

  return (
    <Box backgroundColor='primary'>
      <Card orientation='vertical' className='c-common-only-visible-in-print'>
        <Box padding='none'>
          {`Counter temperature report from the ${moment(props.batchDate).format('DD/MM/YYYY')}`}
        </Box>
      </Card>

      {props.counterTemperatureResponse.counterTemperatures.filter(
        (cabinets) => cabinets.cabinetTemperatures.length > 0,
      ).length > 0 && (
        <Grid gap='lg' cols={{ xs: 1, sm: 2, md: 3, lg: 3 }}>
          {renderSummary(
            'Checks completed on time',
            `${props.counterTemperatureResponse.checksCompletedOnTime}%`,
            props.counterTemperatureResponse.checksCompletedOnTime > 0
              ? '#2e7d32'
              : 'var(--fable-color-text-error)',
          )}
          {renderSummary(
            'Checks overdue',
            `${props.counterTemperatureResponse.checksOverdue}%`,
            props.counterTemperatureResponse.checksOverdue > 0
              ? 'var(--fable-color-text-error)'
              : '#2e7d32',
          )}
          {renderSummary(
            'Manual temperature checks',
            props.counterTemperatureResponse.manualTemperatureChecks.toString(),
            '',
          )}
        </Grid>
      )}

      {props.counterTemperatureResponse.counterTemperatures.map(
        (counterTemperature, index) =>
          (counterTemperature.cabinetSummary.length > 0 ||
            counterTemperature.cabinetTemperatures.length > 0) && (
            <div key={index}>
              <CounterTemperatureTable
                counterTemperature={counterTemperature}
              />
            </div>
          ),
      )}

      <Card orientation='vertical'>
        <div className='c-common-only-visible-in-print'>{getPrintFooter()}</div>
        <Flex direction='column' alignItems='center'>
          <Button
            className='c-common-hide-in-print'
            onClick={() => window.print()}
            testid='print-button'
            style={{ marginTop: '16px' }}
          >
            Print Report
          </Button>
        </Flex>
      </Card>
    </Box>
  )
}

export default CounterView
